/**
 *
 * Label Input
 *
 * @param {*} props
 *
 * props: {
 *   label: string
 *    hasValue: boolean
 * }
 *
 * @returns
 */
export const FieldLabel = (
  props = {
    label: undefined,
    require: false,
    hasInput: false
  }
) => {
  if (!props?.label) return <></>
  return (
    <div className={''}>
      <label
        className={'paragraph-xs font-bold text-primary-black'}
      >
        {props.label}
        {props?.required && '*'}
      </label>
    </div>
  )
}
